import React from "react"

import FieldProto_ConditionForm from "../../../../proto/render/condition/condition-form"

import FieldProject from "../project"
import ConditionTypeSelector from "../../../../proto/render/condition/condition-type-selector"
import SelectParentsNew from "../../../../../gd-ui/select-parent-new/select-parents-new"
import {SelectParent_RenderType} from "../../../../../gd-ui/select-parent-new/@const"
import ProjectSession from "../../../../../model2/project/project-session"
import getAvailableProjectsByViewType from "../../../../../views/functions/get-available-projects"
import {ViewType} from "../../../../../gd/const/views/view-type"

// const debug = "FieldExpenseProject_ConditionForm"
const debug = false

export default class FieldExpenseProject_ConditionForm extends FieldProto_ConditionForm {

    onChangeFieldValues = (projectIds: ID[]) => {
        this.onChangeValue(projectIds)
    }

    render() {
        const field: FieldProject = this.props.field as FieldProject

        debug && console.log(debug, 'render', field)

        let filterProjects : any[] = []
        gd.session.projectUsers.map((pu:any)=>{
            if (pu.project && pu.user && pu.user.id === gd.session.me.id) {
                const project = gd.session.projects.get(pu.project.id)
                const expensesEnabled = _.get(project, 'properties.expenses', false)
                if (expensesEnabled) filterProjects.push(project)
            }
        })
        filterProjects = _.uniqBy(filterProjects, (project: ProjectSession) => project.id)

        return (
            <>
                <ConditionTypeSelector field    = {this.props.field}
                                       value    = {this.props.condition.type}
                                       onChange = {this.onChangeType}/>

                <SelectParentsNew className         = "w-250 m-l-10"
                                  renderType        = {SelectParent_RenderType.FORM}
                                  placeholder       = "Any"
                                  unselectLabel     = "Any"
                                  availableProjects = {getAvailableProjectsByViewType(ViewType.PROJECT_EXPENSES)}
                                  projectIds        = {this.props.condition.value}
                                  onChange          = {this.onChangeFieldValues}/>

                {/*<SelectParent className         = "m-l-10"
                              curValueClasses   = "w-250"
                              renderValue       = "form"
                              parentsFor        = {field.parentsFor}
                              viewMode          = {field.viewMode}
                              multiselect       = {true}
                              placeholder       = "Any"
                              unselectLabel     = "Any"
                              companies         = {[gd.companyId]}
                              values            = {this.props.condition.value ? {projects: this.props.condition.value} : null}
                              accessLevels      = {field.accessLevels}
                              filterProjects    = {filterProjects}
                              showProjectIcon   = {true}
                              showIcon          = {true}
                              searchable        = {true}
                              onChange          = {this.onChangeFieldValues}/>*/}
            </>
        )
    }
}